import { inject, observer } from "mobx-react";
import React from "react";
import { Avatar } from "src/components";
import { Badge } from "src/components/badge";
import { FloatingMenu } from "src/components/floatingMenu";
import { theme } from "src/config";
import { Item, User } from "src/models";
import { Logs } from "src/pages";
import { Documents } from "src/pages";
import { MatchParams } from "src/routes";
import { AuthStore, ItemStore, SpaceStore, UserStore } from "src/stores";
import { DataType, IItem, ItemType, UserRole } from "src/types";
import styled from "styled-components";
import { EditItem } from "./editData";
import { ItemView } from "./itemView";
import { MeetingView } from "./meetingView";
import { RoomArchive } from "./roomArchive";

export interface IDefaultProps {
  itemStores?: { [type: string]: ItemStore<Item<IItem>, IItem> };
  authStore?: AuthStore;
  spaceStore?: SpaceStore;
  userStore?: UserStore;
  params: MatchParams; // This is injected so it has to be called params
}

export const Room = inject("spaceStore", "itemStores", "authStore", "userStore")(observer((props: IDefaultProps): JSX.Element => {

  const { params, itemStores, authStore, spaceStore, userStore } = props;
  const view = params.view;

  // React.useEffect(() => {
  //   // If the user has a current room set when routing to this page, change it
  //   if (authStore.getCurRoomID !== Number(params.id)) {
  //     spaceStore.changeRoom(Number(params.id));
  //   }
  // }, [spaceStore.getCurRoom]);

  const getView = (type: string) => {
    switch (type) {
      case DataType.Meeting:
        return <MeetingView />;
      case "documents":
        return <Documents />;
      case "logs":
        return <Logs params={params} />;
      case "archive":
        return <RoomArchive />;
      default:
        return <ItemView type={type as ItemType} />;
    }
  };

  React.useEffect(() => {
    // If the user enters a room with a id in the URL params. Try open that item
    const { item_id, view: type } = props.params;
    if (type === "logs") return;

    if (item_id) itemStores[type].setActiveById(item_id);
  }, [props.params]);

  const users: User[] = userStore.getOnlineUsers.slice();
  
  return (
    <>
      {getView(view)}
      <EditItem />
      <>
        <OnlineUserContainer key={authStore.getCurRoomID + '-' + users.length}>
          {users.map((u) => (
            <UserContainer key={u.id}>
                <StyledAvatar
                  key             = {u.avatar}
                  online          = {true}
                  size            = "medium"
                  leaderBadge     = {u.canEdit}
                  image           = {u.getAvatar}
                  backgroundColor = {theme.color.grayDark}
                  initials        = {u.getInitials}
                  hoverInitials   = {true}
                />
            </UserContainer>
          ))}
        </OnlineUserContainer>
        <FloatingMenu type={view as ItemType} />
      </>
    </>
  );
}));

const OnlineUserContainer = styled.div`
  bottom: 2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  right: 10rem;
  position: fixed;
  z-index: 2;
`;

const StyledAvatar = styled(Avatar)`
  margin-top: 0.5rem;
`;

const UserContainer = styled.div`
  padding: 0.5rem 0.5rem;
`;
